import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {AbstractComponent} from "../abstract.component";
import {DOCUMENT} from "@angular/common";
import {CompetitorResultsService, LoaderService} from "@services";
import {TranslocoService} from "@ngneat/transloco";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {
  CompetitorResults,
  MeasurementTypes,
  Race, ResultProcessingType,
} from "@model";

@Component({
    selector: 'app-results-table-mobile-list-item',
    templateUrl: './results-table-mobile-list-item.component.html',
    styleUrl: './results-table-mobile-list-item.component.scss',
    standalone: false
})
export class ResultsTableMobileListItemComponent extends AbstractComponent implements OnInit{

  @Input() isLast: boolean = false;
  @Input() competitor: CompetitorResults | undefined;
  @Input() category: number | undefined = undefined;
  @Input() gender: number | undefined = undefined;
  @Input() isAdmin: boolean = false;
  @Input() firstCompetitorResults: CompetitorResults | undefined = undefined;
  @Input() measurementType: number | undefined = undefined;
  @Input() race: Race | undefined;
  @Input() isRound: boolean = false;
  @Input() isFullScreen: boolean = false;
  @Output() onOpenDetails = new EventEmitter<void>();


  isTeam: boolean = false;

  constructor(@Inject(DOCUMENT) private document: Document, private loaderService: LoaderService, private translocoService: TranslocoService,
              private competitorResultsService: CompetitorResultsService, private modalService: NgbModal) {
    super();
  }

  ngOnInit() {
    this.isTeam = !!(this.competitor?.competitorResultsDetail?.team && this.competitor?.competitorResultsDetail?.team.length)
  }

  openDetailsModal() {
    this.onOpenDetails.emit();
  }



  protected readonly Array: ArrayConstructor = Array;
  protected readonly MeasurementTypes = MeasurementTypes;
  protected readonly ResultProcessingType = ResultProcessingType;


}
